import { Outlet, useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import ThemeToggle from '../../components/ThemeToggle';
import HalloweenToggle from '../../components/HalloweenToggle';
import logo from '../../assets/logo-badge.webp';
import ImpersonationBanner from '../../components/ImpersonationBanner';

export default function TeacherLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  async function doLogout() { await logout(); navigate('/login'); }

  return (
    <div className="flex min-h-full flex-col bg-canvas">
      <header className="sticky top-0 z-20 border-b border-line bg-surface/95 backdrop-blur">
        <div className="mx-auto flex max-w-2xl items-center justify-between px-4 py-3">
          <div className="flex items-center gap-2">
            <img src={logo} alt="Let's Move" className="h-8 w-8 rounded-full bg-white object-contain ring-1 ring-accent/40" />
            <div>
              <div className="font-display text-base font-bold leading-none text-content">Let's Move</div>
              <div className="text-[11px] text-content-3">Profesor · {user?.firstname}</div>
            </div>
          </div>
          <div className="flex items-center gap-1">
            <HalloweenToggle />
            <ThemeToggle />
            <button onClick={doLogout} className="rounded-lg p-2 text-content-3 transition hover:bg-surface-2 hover:text-content" title="Salir" aria-label="Salir">
              <LogOut size={18} />
            </button>
          </div>
        </div>
      </header>
      <main className="mx-auto w-full max-w-2xl flex-1 px-4 py-5">
        <Outlet />
      </main>
      <ImpersonationBanner />
    </div>
  );
}
